import { Container } from "@mui/material";
import Page from "../components/Page";

export default function CompletedTrafficPage({ children }) {
    return (
        <Page title="Completed Traffic | HCC">
            <Container maxWidth="xl">{children}</Container>
        </Page>
    );
}
